import React, { createContext, useContext } from 'react';
import { useLoadScript } from '@react-google-maps/api';

const libraries = ['places'];

const GoogleMapsContext = createContext({
    isLoaded: false,
    loadError: null
});

export const useGoogleMaps = () => useContext(GoogleMapsContext);

export const GoogleMapsLoader = ({ children }) => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: apiKey || '',
        libraries: libraries,
        preventGoogleFontsLoading: true
    });

    if (!apiKey) {
        return (
            <GoogleMapsContext.Provider value={{ isLoaded: false, loadError: 'No API key' }}>
                {children}
            </GoogleMapsContext.Provider>
        );
    }

    return (
        <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
            {children}
        </GoogleMapsContext.Provider>
    );
};
